import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=36769ce3&scoped=true"
import script from "./MultiSelect.vue?vue&type=script&lang=ts"
export * from "./MultiSelect.vue?vue&type=script&lang=ts"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=36769ce3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36769ce3",
  null
  
)

export default component.exports